// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.6.1
//   protoc               v3.20.3
// source: src/proto/models.proto
/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
export const protobufPackage = "";
function createBaseAppData() {
    return { entrypoint: "", files: {}, requirements: [] };
}
export const AppData = {
    encode(message, writer = new BinaryWriter()) {
        if (message.entrypoint !== "") {
            writer.uint32(10).string(message.entrypoint);
        }
        Object.entries(message.files).forEach(([key, value]) => {
            AppData_FilesEntry.encode({ key: key, value }, writer.uint32(18).fork()).join();
        });
        for (const v of message.requirements) {
            writer.uint32(26).string(v);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseAppData();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.entrypoint = reader.string();
                    continue;
                }
                case 2: {
                    if (tag !== 18) {
                        break;
                    }
                    const entry2 = AppData_FilesEntry.decode(reader, reader.uint32());
                    if (entry2.value !== undefined) {
                        message.files[entry2.key] = entry2.value;
                    }
                    continue;
                }
                case 3: {
                    if (tag !== 26) {
                        break;
                    }
                    message.requirements.push(reader.string());
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            entrypoint: isSet(object.entrypoint) ? globalThis.String(object.entrypoint) : "",
            files: isObject(object.files)
                ? Object.entries(object.files).reduce((acc, [key, value]) => {
                    acc[key] = File.fromJSON(value);
                    return acc;
                }, {})
                : {},
            requirements: globalThis.Array.isArray(object?.requirements)
                ? object.requirements.map((e) => globalThis.String(e))
                : [],
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.entrypoint !== "") {
            obj.entrypoint = message.entrypoint;
        }
        if (message.files) {
            const entries = Object.entries(message.files);
            if (entries.length > 0) {
                obj.files = {};
                entries.forEach(([k, v]) => {
                    obj.files[k] = File.toJSON(v);
                });
            }
        }
        if (message.requirements?.length) {
            obj.requirements = message.requirements;
        }
        return obj;
    },
    create(base) {
        return AppData.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseAppData();
        message.entrypoint = object.entrypoint ?? "";
        message.files = Object.entries(object.files ?? {}).reduce((acc, [key, value]) => {
            if (value !== undefined) {
                acc[key] = File.fromPartial(value);
            }
            return acc;
        }, {});
        message.requirements = object.requirements?.map((e) => e) || [];
        return message;
    },
};
function createBaseAppData_FilesEntry() {
    return { key: "", value: undefined };
}
export const AppData_FilesEntry = {
    encode(message, writer = new BinaryWriter()) {
        if (message.key !== "") {
            writer.uint32(10).string(message.key);
        }
        if (message.value !== undefined) {
            File.encode(message.value, writer.uint32(18).fork()).join();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseAppData_FilesEntry();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.key = reader.string();
                    continue;
                }
                case 2: {
                    if (tag !== 18) {
                        break;
                    }
                    message.value = File.decode(reader, reader.uint32());
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            key: isSet(object.key) ? globalThis.String(object.key) : "",
            value: isSet(object.value) ? File.fromJSON(object.value) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.key !== "") {
            obj.key = message.key;
        }
        if (message.value !== undefined) {
            obj.value = File.toJSON(message.value);
        }
        return obj;
    },
    create(base) {
        return AppData_FilesEntry.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseAppData_FilesEntry();
        message.key = object.key ?? "";
        message.value = (object.value !== undefined && object.value !== null) ? File.fromPartial(object.value) : undefined;
        return message;
    },
};
function createBaseFile() {
    return { content: undefined };
}
export const File = {
    encode(message, writer = new BinaryWriter()) {
        switch (message.content?.$case) {
            case "text":
                writer.uint32(10).string(message.content.text);
                break;
            case "data":
                writer.uint32(18).bytes(message.content.data);
                break;
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseFile();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.content = { $case: "text", text: reader.string() };
                    continue;
                }
                case 2: {
                    if (tag !== 18) {
                        break;
                    }
                    message.content = { $case: "data", data: reader.bytes() };
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            content: isSet(object.text)
                ? { $case: "text", text: globalThis.String(object.text) }
                : isSet(object.data)
                    ? { $case: "data", data: bytesFromBase64(object.data) }
                    : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.content?.$case === "text") {
            obj.text = message.content.text;
        }
        else if (message.content?.$case === "data") {
            obj.data = base64FromBytes(message.content.data);
        }
        return obj;
    },
    create(base) {
        return File.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseFile();
        switch (object.content?.$case) {
            case "text": {
                if (object.content?.text !== undefined && object.content?.text !== null) {
                    message.content = { $case: "text", text: object.content.text };
                }
                break;
            }
            case "data": {
                if (object.content?.data !== undefined && object.content?.data !== null) {
                    message.content = { $case: "data", data: object.content.data };
                }
                break;
            }
        }
        return message;
    },
};
function bytesFromBase64(b64) {
    if (globalThis.Buffer) {
        return Uint8Array.from(globalThis.Buffer.from(b64, "base64"));
    }
    else {
        const bin = globalThis.atob(b64);
        const arr = new Uint8Array(bin.length);
        for (let i = 0; i < bin.length; ++i) {
            arr[i] = bin.charCodeAt(i);
        }
        return arr;
    }
}
function base64FromBytes(arr) {
    if (globalThis.Buffer) {
        return globalThis.Buffer.from(arr).toString("base64");
    }
    else {
        const bin = [];
        arr.forEach((byte) => {
            bin.push(globalThis.String.fromCharCode(byte));
        });
        return globalThis.btoa(bin.join(""));
    }
}
function isObject(value) {
    return typeof value === "object" && value !== null;
}
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=models.js.map